<ndt-tile-set-type-select-view
   [tileId]="tileId"
   [tileSet]="tileSet$ | async"
   (tileSetTypeChange)="onTileSetTypeChange($event)"
></ndt-tile-set-type-select-view>
